import styled from 'styled-components';

import { flexAllCenter, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

import type { VotingPageKind } from './VotingPageHero';

export const Background = styled.div<{ $kind: VotingPageKind }>`
    padding: 10% ${({ $kind }) => ($kind === 'governance' ? '4rem' : '0')};
    ${flexAllCenter};
    flex-direction: column;
    background-color: ${COLORS.heroBackground};
    min-height: 10rem;
    max-height: ${({ $kind }) => ($kind === 'governance' ? '40vh' : '50vh')};
    overflow: hidden;
    position: relative;

    ${respondDown(Breakpoints.md)`
        padding-left: 1.6rem;
        padding-right: 1.6rem;
    `}
`;

export const Illustration = styled.img<{ $right?: boolean }>`
    position: absolute;
    top: 0;
    ${({ $right }) => ($right ? 'right: 0;' : 'left: 0;')}
    height: 100%;
    pointer-events: none;

    ${respondDown(Breakpoints.md)`
        height: auto;
        width: 40%;
        top: 50%;
        transform: translateY(-50%);
    `}
`;

export const Title = styled.h2<{ $kind: VotingPageKind }>`
    font-size: ${({ $kind }) => ($kind === 'governance' ? '8rem' : '6rem')};
    line-height: 9.4rem;
    font-weight: bold;
    color: ${COLORS.white};
    z-index: 1;
    margin-bottom: 1.6rem;
    text-align: center;

    ${respondDown(Breakpoints.lg)`
        font-size: ${({ $kind }) => ($kind === 'governance' ? '7rem' : '5.5rem')};
        line-height: 8rem;
        margin-bottom: 1.2rem;
    `}
    ${respondDown(Breakpoints.md)`
        font-size: ${({ $kind }) => ($kind === 'governance' ? '5.5rem' : '5rem')};
        line-height: 6rem;
        margin-bottom: 1rem;
    `}
    ${respondDown(Breakpoints.sm)`
        font-size: 4rem;
        line-height: 5rem;
        margin-bottom: 0.8rem;
    `}
`;

export const Description = styled.div`
    max-width: 79.2rem;
    font-size: 1.6rem;
    line-height: 2.8rem;
    color: ${COLORS.white};
    text-align: center;
    opacity: 0.7;
    z-index: 1;
`;
